__turbopack_context__.v({
  "arrow": "uJdyqG_arrow",
  "arrowDisabled": "uJdyqG_arrowDisabled",
  "arrowRight": "uJdyqG_arrowRight",
  "closeIcon": "uJdyqG_closeIcon",
  "image": "uJdyqG_image",
  "magnifier": "uJdyqG_magnifier",
  "preview": "uJdyqG_preview",
  "wrapper": "uJdyqG_wrapper",
});
